/* eslint-disable */
import { useEffect, useState } from "react";
import "../../styles/DiversionPage.css";
import diversion from "../../assets/titulos/diversion.png";
import fun from "../../assets/titles/fun.png";

import juguetes from "../../assets/diversion/juguetes.jpg";
import motos from "../../assets/diversion/motos.jpeg";
import pesca from "../../assets/diversion/pesca.jpg";
import { useTranslation } from "react-i18next";
import LocalizedTitleImage from "../../components/UseLanguage";
import menuIcon from "../../assets/menu.png";

function DiversionPage() {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

  const cardData = [
    {
      img: motos,
      title: t("diversion.motos.titulo"),
      text: t("diversion.motos.texto"),
    },
    {
      img: juguetes,
      title: t("diversion.juguetes.titulo"),
      text: t("diversion.juguetes.texto"),
    },
    {
      img: pesca,
      title: t("diversion.pesca.titulo"),
      text: t("diversion.pesca.texto"),
    },
  ];

  const layoutDesktop = (
    <>
      <div className="div-card-row2">
        {cardData.map((item, i) => (
          <img
            key={i}
            src={item.img}
            alt={item.title}
            className="div-card-img"
          />
        ))}
      </div>
      <div className="div-card-row">
        {cardData.map((item, i) => (
          <div key={i} className="div-card">
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </div>
        ))}
      </div>
    </>
  );

  const layoutMobile = (
    <div className="mobile-div-wrapper">
      {cardData.map((item, i) => (
        <div className="mobile-item" key={i}>
          <img src={item.img} alt={item.title} className="div-card-img" />
          <div className="div-card">
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="diversion-page fade-tab">
      <div className="menu-icon-diver">
        <img src={menuIcon} />
      </div>
      <div className="diversion-title-wrapper">
        <LocalizedTitleImage
          imageEn={fun}
          imageEs={diversion}
          className="diversion-title-img"
        />
      </div>
      <div className="fade-wrapper">
        {isMobile ? layoutMobile : layoutDesktop}
      </div>
    </div>
  );
}

export default DiversionPage;
